import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Landing from './pages/Landing';
import SignupSuccess from './pages/SignupSuccess';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import './App.css';

// Google Analytics page view tracker
function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // Send pageview to Google Analytics on route change
    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', 'G-WDVJED16PJ', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
}

function AppRoutes() {
  usePageTracking();

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/success" element={<SignupSuccess />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route path="/admin/dashboard" element={<AdminDashboard />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;